const DictionaryNamePage = {
  '/properties/propertyimporter': 'Propertyimporter',
  '/properties/propertyimporter/importreport': 'Importreport',
  '/contacts/duplicated': 'Duplicatedcontacts',
  '/marketing/webcontact/config': 'InquiriesSettings',
  '/marketing/webcontact/config/report': 'AssignmentReport',
  '/marketing/webcontact/config/webcontact-rule': 'InquiriesSettings',
  '/portals/instagram/post': 'Instagrampost',
  '/company/properties': 'PropertiesConfiguration',
  '/company/importer': 'Importer',
  '/company/importer/new': 'NewImport',
  '/company/file-manager': 'FileManager',
  '/company/permissions': 'Permissions',
  '/company/permissions/group': 'PermissionGroup',
  '/company/networks-and-associations': 'NetworksAndAssociations',
  '/company/networks-and-associations/participants': 'Participants',
  '/company/networks-and-associations/edit': 'EditNetwork',
  '/webmanager': 'WebSites',
  '/webmanager/templatelist': 'TemplateList',
  '/webmanager/templateconfig': 'TemplateConfiguration',
  '/portals/publications/instagram': 'InstagramPublicationsTab',
  '/portals/config': 'PortalSettings',
  '/portals/config/starring-rule': 'PublicationRuleSettings',
  '/properties/visit': 'PropertyVisits',
  '/properties/visit/settings': 'BookingSettings',
  '/home': 'Home',
  '/leads': 'Leads',
  '/leads/panel': 'Leads',
  '/whatsapp/dashboard': 'WhatsAppConfiguration',
  '/whatsapp/cloud-api': 'WhatsAppCloudApi',
  '/developments': 'Developments',
  '/company/configuration': 'GeneralSettings',
  '/company/pdf-configuration': 'FileAndPdfSettings',
  '/properties/listingRegistration': 'ListingRegistration',
  '/marketing/webcontact/config/outside-of-working-hours-rule':
    'OutsideOfWorkingHoursRule',
  '/tasks': 'Tasks',
  '/change-requests': 'ChangeRequestsApprovals',
  '/company/event-types': 'EventTypes',
  '/company/event-types/form': 'EventTypes',
  '/company/referenceCodes': 'ReferenceCodes',
  '/company/referenceCodes/global': 'GlobalReferenceCodes',
  '/company/referenceCodes/exclusive': 'ExclusiveReferenceCodes',
  '/company/branches-and-teams': 'BranchesAndTeams',
  '/company/leads-configuration': 'LeadsConfiguration',
  '/company/agent-management': 'AgentManagement',
  '/company/agent-management/create': 'CreateAgent',
  '/user': 'Profile',
  '/newsletters': 'Newsletter',
  '/newsletters/detail': 'Newsletter',
  '/design-system': 'DesignSystem',
};

export default DictionaryNamePage;
